import React, { Component } from 'react';
import { BrowserRouter, HashRouter, Route, Switch } from 'react-router-dom';
import { Icon } from 'antd-mobile';
import Loadable from 'react-loadable';
import { Provider, Subscribe } from 'unstated';

import BasketContainer from './containers/BasketContainer';
const TOP_NAV_HEIGHT = 60;

const h = document.documentElement.clientHeight;
const w = document.documentElement.clientWidth;

const Router = props => {
  return window.matchMedia('(display-mode: standalone)').matches ? (
    <HashRouter {...props} />
  ) : (
    <BrowserRouter {...props} />
  );
};

const Loading = () => {
  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100%',
        width: w,
        height: h,
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Icon type="loading" size="lg" />
    </div>
  );
};
const Home = Loadable({
  loader: () => import('./pages/Home'),
  loading: Loading
});
const AddressLookUp = Loadable({
  loader: () => import('./pages/AddressLookUp'),
  loading: Loading
});
const SERP = Loadable({
  loader: () => import('./pages/SERP'),
  loading: Loading
});
const Restaurant = Loadable({
  loader: () => import('./pages/Restaurant'),
  loading: Loading
});

const ConfirmDetails = Loadable({
  loader: () => import('./pages/ConfirmDetails'),
  loading: Loading
});

const Payments = Loadable({
  loader: () => import('./pages/Payments'),
  loading: Loading
});
class App extends Component {
  state = {
    currentPage: 'home',
    selectedAddressObj: {},
    restoObj: {},
    prevPage: null
  };
  handleUpdateCurrentPage = (currentPage, obj) => {
    const prevPage = this.state.currentPage;
    this.setState({ currentPage, ...obj, prevPage });
  };

  render() {
    return (
      <Provider>
        <div
          className="App"
          style={{ overflow: 'hidden', height: '100vh', width: '100vw' }}
        >
          <Subscribe to={[BasketContainer]}>
            {basket => {
              return (
                <Router>
                  <Switch>
                    <Route
                      exact
                      path="/"
                      render={props => {
                        return (
                          <Home
                            {...props}
                            h={h}
                            w={w}
                            topNavHeight={TOP_NAV_HEIGHT}
                            updateCurrentPage={this.handleUpdateCurrentPage}
                          />
                        );
                      }}
                    />
                    <Route
                      path="/find-restaurants"
                      render={props => {
                        return (
                          <AddressLookUp
                            {...props}
                            h={h}
                            w={w}
                            topNavHeight={TOP_NAV_HEIGHT}
                            updateCurrentPage={this.handleUpdateCurrentPage}
                          />
                        );
                      }}
                    />
                    <Route
                      exact
                      path="/restaurants"
                      render={props => {
                        return (
                          <SERP
                            {...props}
                            h={h}
                            w={w}
                            basket={basket}
                            topNavHeight={TOP_NAV_HEIGHT}
                            updateCurrentPage={this.handleUpdateCurrentPage}
                            selectedAddressObj={this.state.selectedAddressObj}
                            prevPage={this.state.prevPage}
                            basketValue={this.state.basketValue}
                          />
                        );
                      }}
                    />
                    <Route
                      path="/restaurants/:id"
                      render={props => {
                        return (
                          <Restaurant
                            {...props}
                            basket={basket}
                            h={h}
                            w={w}
                            topNavHeight={TOP_NAV_HEIGHT}
                            updateCurrentPage={this.handleUpdateCurrentPage}
                            prevPage={this.state.prevPage}
                            restoObj={this.state.restoObj}
                          />
                        );
                      }}
                    />
                    <Route
                      path="/confirm-details"
                      render={props => {
                        return (
                          <ConfirmDetails
                            {...props}
                            basket={basket}
                            h={h}
                            w={w}
                            topNavHeight={TOP_NAV_HEIGHT}
                            updateCurrentPage={this.handleUpdateCurrentPage}
                            prevPage={this.state.prevPage}
                            restoObj={this.state.restoObj}
                          />
                        );
                      }}
                    />
                    <Route
                      path="/payments"
                      render={props => {
                        return (
                          <Payments
                            {...props}
                            basket={basket}
                            h={h}
                            w={w}
                            topNavHeight={TOP_NAV_HEIGHT}
                            updateCurrentPage={this.handleUpdateCurrentPage}
                            prevPage={this.state.prevPage}
                            restoObj={this.state.restoObj}
                          />
                        );
                      }}
                    />
                  </Switch>
                </Router>
              );
            }}
          </Subscribe>
        </div>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js